import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	items: [],
	mode: null,
	info: {},
};

export const basketSlice = createSlice({
	name: "basket",
	initialState,
	reducers: {
		addBasket: (state, action) => {
			const product = action.payload;
			let foundProduct = state.items.find(
				(p) =>
					p.productId === product.productId &&
					p.type === "product" &&
					p.price == product.price &&
					(!product.selectedOptions || !product.selectedOptions.length) &&
					(!p.selectedOptions || !p.selectedOptions.length)
			);
			if (foundProduct !== undefined) {
				foundProduct.quantity++;
			} else {
				product.timestamp = product.timestamp || Date.now();
				state.items.push(product);
			}
			state.updatedAt = Date.now();
		},

		removeFromBasket: (state, action) => {
			state.items = state.items.filter(
				(item) => item.timestamp !== action.payload.timestamp
			);
			state.updatedAt = Date.now();
		},

		changeQuantity: (state, action) => {
			const product = action.payload.product;
			const quantity = action.payload.quantity;
			const foundProduct = state.items.find((p) => p.id === product.id);
			if (foundProduct !== undefined) {
				foundProduct.quantity += quantity;
				if (foundProduct.quantity <= 0) {
					state.items = state.items.filter(
						(item) => item.timestamp !== action.payload.timestamp
					);
				}

				state.updatedAt = Date.now();
			}
		},
		setMode: (state, action) => {
			state.mode = action.payload.mode;
			if (action.payload.mode === "delivery") {
				state.deliveryFees = action.payload.deliveryFees;
			} else {
				state.deliveryFees = 0;
			}
			state.updatedAt = Date.now();
		},
		setOrderRequestedTime: (state, action) => {
			state.requestedTime = action.payload;
			state.updatedAt = Date.now();
		},
		setOrderInfo: (state, action) => {
			state.info = action.payload;
			state.updatedAt = Date.now();
		},

		clearBasket: (state, action) => {
			state.items = [];
			state.requestedTime = {};
			state.info = {};
			state.mode = null;
			state.order = null;
			state.deliveryFees = 0;
			state.updatedAt = Date.now();
		},
		setOrder: (state, action) => {
			state.order = action.payload;
		},
		updateItems: (state, action) => {
			let items = action.payload.items;
			state.items = [];
			items.forEach((it, ind) => {
				state.items.push({
					...it,
					price: it.price,
					basePrice: it.basePrice,
				});
			});
			state.updatedAt = Date.now();
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	addBasket,
	removeFromBasket,
	changeQuantity,
	clearBasket,
	setMode,
	setOrderInfo,
	setOrderRequestedTime,
	setOrder,
	updateItems,
} = basketSlice.actions;

export default basketSlice.reducer;
